import { Button, Flex, Modal } from "antd";
import React from "react";
import Title from "antd/es/typography/Title";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomTitle } from "../../../../../common/customTitle";
import { completeAppointmentAction, updatePackageServiceStatusAction } from "../../../../../../redux/services/service-provider-appointments/serviceProviderAppointmentsServices";
import { useTranslation } from "react-i18next";

const CompleteOrderDialog = ({ open, onClose }) => {
  const {t} = useTranslation();
  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* id dependencies */
  const { selectedAppointmentsInfoId, selectedAppointmentOrderType, selectedAppointmentPackageServiceId } = useSelector(
    (state) => state.serviceProviderAppointments
  );
  /* id dependencies */

  /* perform completion action */
  const handleComplete = () => {
    if (
      selectedAppointmentsInfoId &&
      selectedAppointmentsInfoId !== "" &&
      selectedAppointmentsInfoId !== null &&
      selectedAppointmentsInfoId !== undefined
    ) {

      if(selectedAppointmentOrderType === "package") {

        const dataToBeSentForUpdateServiceStatus = {
          selectedAppointmentsInfoId,
          service_id:selectedAppointmentPackageServiceId,
          status:"COMPLETED"
        };

        dispatch(updatePackageServiceStatusAction(dataToBeSentForUpdateServiceStatus, setLoading)).then(() => {
          onClose();
        });
      }
      else {
        const dataToBeSent = {
          selectedAppointmentsInfoId,
        };

        dispatch(completeAppointmentAction(dataToBeSent, setLoading)).then(() => {
          onClose();
        });
      }
      onClose();

    } else {
      onClose();
    }
  };
  /* perform completion action */

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {t("appointmentInfo.completeOrder")}
        </CustomTitle>
        <Title level={2}>{t("appointmentInfo.completeOrderTitle")}</Title>
        <Flex gap="1rem" align="center" justify="center">
          <Button type="primary" onClick={handleComplete}>
          {t("confirmationPopup.buttonYesText")}
          </Button>
          <Button type="default" onClick={onClose}>
          {t("confirmationPopup.buttonNoText")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default CompleteOrderDialog;
